import Api from "../api";
let uri = '/api/ed/bloqueo';

export const getBloqueos = (data) => {
    return Api.getInstance().executeQuery(`${uri}/list`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const adminBloqueo = (data) => {
    return Api.getInstance().executeQuery(`${uri}/upsert`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const desactivarBloqueo = (data) => {
    return Api.getInstance().executeQuery(`${uri}/desactivar`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}



